import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Box, FormHelperText } from "__barrel_optimize__?names=Box,FormHelperText!=!@mui/material";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import { DatePicker } from "@mui/x-date-pickers/DatePicker";
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import { useParams } from "next/navigation";
import "dayjs/locale/de";
import React from "react";
const StyledDatePicker = /*#__PURE__*/ React.forwardRef((props, ref)=>{
    const { helperText, disablePast, ...rest } = props;
    const params = useParams();
    const locale = params && params.lng === "de" ? "de" : "en";
    const localeText = locale === "de" ? {
        datePickerToolbarTitle: "Datum ausw\xe4hlen",
        cancelButtonLabel: "Abbrechen",
        clearButtonLabel: "L\xf6schen",
        okButtonLabel: "OK",
        todayButtonLabel: "Heute"
    } : undefined;
    return /*#__PURE__*/ _jsxs(Box, {
        position: "relative",
        children: [
            /*#__PURE__*/ _jsx(LocalizationProvider, {
                dateAdapter: AdapterDayjs,
                adapterLocale: locale,
                localeText: localeText,
                children: /*#__PURE__*/ _jsx(DatePicker, {
                    ref: ref,
                    sx: {
                        width: "100%",
                        ".MuiInputBase-root": {
                            height: "53px",
                            fontSize: "14px",
                            fontWeight: 500
                        }
                    },
                    disablePast: disablePast || false,
                    ...rest
                })
            }),
            helperText ? /*#__PURE__*/ _jsx(FormHelperText, {
                sx: {
                    color: "#bf3333",
                    marginLeft: "16px !important",
                    position: "absolute"
                },
                children: helperText && helperText
            }) : null
        ]
    });
});
StyledDatePicker.displayName = "StyledDatePicker";
export default StyledDatePicker;
